const constants = {
  specEstablishmentId: "00000000-0000-0000-0000-000000000001"
}

export default constants